var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list',{attrs:{"hide-delete":"","hide-edit":"","hide-select":"","headers":"utility_code,station_N,building_N,address,domoupravitel_name,domoupravitel_phone,domoupravitel_email","filter":_vm.filter,"item-class":()=>'cursor-pointer'},on:{"click:row":_vm.clickRow}})
}
var staticRenderFns = []

export { render, staticRenderFns }